import React from 'react';
import PropTypes from 'prop-types';
import ajax from '../../utils/ajax';
import Button from '../../shared/buttons/Button';
import TextInput from '../../shared/inputs/TextInput';
import ErrorMessage from '../../shared/message/ErrorMessage';
import {
  postTeamAcceptInvitationNewaccountUsingToken,
  postTeamAcceptInvitationUsingToken,
} from '../../api/cloudApiGenerated';

class RedeemInvitePage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.validateForm = this.validateForm.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.updateState = this.updateState.bind(this);
    this.getFormComponents = this.getFormComponents.bind(this);

    this.state = {
      form: {
        name: {
          value: '',
          error: false,
        },
        password: {
          value: '',
          error: false,
        },
        passwordConfirmation: {
          value: '',
          error: false,
        },
      },
      token: props.match.params.token,
      isNewUser: props.match.params.type === 'new', // type is either 'new' or 'add'
      error: '',
    };
  }

  onSubmit(event) {
    event.preventDefault();
    let { form, isNewUser, token } = this.state;
    const valid = !isNewUser || this.validateForm();
    if (!valid) {
      return;
    }

    if (isNewUser) {
      postTeamAcceptInvitationNewaccountUsingToken(token, {
        username: form.name.value,
        password: form.password.value,
      })
        .then((result) => {
          ajax.assignToken(result.token);

          this.props.history.replace({
            pathname: this.props.paths.profileCharts,
          });

          this.props.onLoggedIn();
        })
        .catch((error) => {
          this.setState({
            error: (error.message.join && error.message.join(' ')) || error.message,
          });
        });
    }

    if (!isNewUser) {
      postTeamAcceptInvitationUsingToken(token)
        .then(() => {
          if (this.state.loggedIn) {
            this.props.history.push({
              pathname: this.props.paths.profileCharts,
              state: {
                overrideRedirect: true,
              },
            });

            this.props.onLoggedIn();
          } else {
            this.props.history.push({
              pathname: this.props.paths.login,
              state: {
                overrideRedirect: true,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            error: (error.message.join && error.message.join(' ')) || error.message,
          });
        });
    }
  }

  updateState(event) {
    const field = event.target.name;
    let form = this.state.form;
    form[field].value = event.target.value;
    form[field].error = false;
    return this.setState({ form });
  }

  validateForm() {
    let form = this.state.form;
    let valid = true;

    if (form.name.value.length < 2) {
      form.name.error = 'Your name needs to be at least 2 characters long';
    } else {
      form.name.error = false;
    }

    if (form.password.value.length < 8) {
      form.password.error = 'Your password needs to be at least 8 characters long';
      valid = false;
    } else {
      form.password.error = false;
    }

    if (form.password.value !== form.passwordConfirmation.value) {
      form.passwordConfirmation.error = 'The passwords you entered do not match';
      valid = false;
    } else {
      form.passwordConfirmation.error = false;
    }

    if (!valid) {
      this.setState({ form });
    }

    return valid;
  }

  getFormComponents() {
    let { form, isNewUser } = this.state;

    let button = [
      <Button
        key="0"
        buttonText="Confirm"
        buttonClass="btn btn-success btn-lg"
        type="submit"
        onClick={this.onSubmit}
      />,
    ];

    let inputs = [
      <TextInput
        key="1"
        label="Name"
        name="name"
        value={form.name.value}
        placeholder={'e.g., Skybert Cloudberg'}
        onChange={this.updateState}
      />,
      <ErrorMessage key="2" error={form.name.error} dismissable={false} />,
      <TextInput
        key="3"
        label="Password"
        name="password"
        type="password"
        value={form.password.value}
        placeholder={'Enter password (minimum 8 characters)'}
        onChange={this.updateState}
      />,
      <ErrorMessage key="4" error={form.password.error} dismissable={false} />,
      <TextInput
        key="5"
        label="Password confirmation"
        name="passwordConfirmation"
        type="password"
        value={form.passwordConfirmation.value}
        placeholder={'e.g., ••••••••••'}
        onChange={this.updateState}
      />,
      <ErrorMessage key="6" error={form.passwordConfirmation.error} dismissable={false} />,
    ];

    return isNewUser ? [...inputs, button] : button;
  }

  render() {
    let { form, isNewUser } = this.state;
    let text = isNewUser
      ? "You're almost there. We just need a few details."
      : "You're all set. Just click to confirm.";

    return (
      <div className={'col-xs-8 accept-invitation-page' + (isNewUser ? ' new-user' : ' existing-user')}>
        <h1>Welcome aboard!</h1>
        <p>{text}</p>
        <form role="form" action={this.onSubmit}>
          <ErrorMessage error={this.state.error} dismissable={false} />
          {this.getFormComponents()}
        </form>
      </div>
    );
  }
}

RedeemInvitePage.propTypes = {
  paths: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  onLoggedIn: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool,
};

export default RedeemInvitePage;
